import styled from 'styled-components';
import { media, theme } from '@styles/Theme';

import bg from '@images/background-intro.jpg';
import logo from '@images/logos/logo-fleury-fertilidade.svg';
import logoSmall from '@images/logos/logo-fleury-fertilidade-small.svg';

export const Wrapper = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100vh;
	background: url(${bg}) no-repeat right center;
	background-size: cover;
`;

export const Box = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 100%;
	max-width: 27rem;
	padding: ${theme.spacing(4)};
	text-align: center;
	background-color: ${theme.colors.neutral.lighter};
	border-radius: ${theme.border.radius.sizes.medium};

	> *:not(:last-child) {
		margin-bottom: ${theme.spacing(3)};
	}

	@media (${media.tablet}) {
		max-width: 30rem;
		padding: ${theme.spacing(6)};
	}

	@media (${media.desktop}) {
		max-width: 41rem;
		padding: ${theme.spacing(8)};
	}
`;

export const LogoWrapper = styled.div`
	img {
		width: 100%;
	}
`;

export const Logo = styled.div`
	width: 12.6rem;
	height: 2.4rem;
	background: url(${logoSmall}) no-repeat;
	background-size: contain;

	@media (${media.desktop}) {
		width: 24.3rem;
		height: 3.2rem;
		background: url(${logo}) no-repeat;
		background-size: contain;
	}
`;
